"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.MobileAppsColumn = void 0;
var _styles = require("./styles");
var _jsxRuntime = require("react/jsx-runtime");
const MobileAppsColumn = ({
  hideOnDesktop
}) => /*#__PURE__*/(0, _jsxRuntime.jsx)(_styles.Root, {
  customSkeletons: [],
  hideOnDesktop: hideOnDesktop,
  children: /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_styles.AppIconSkeleton, {}), /*#__PURE__*/(0, _jsxRuntime.jsx)(_styles.AppIconSkeleton, {})]
  })
});
exports.MobileAppsColumn = MobileAppsColumn;